import React from 'react';
import { Wrench, Clock, AlertTriangle } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const MaintenancePage = ({ message }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      {/* Simple Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center py-4">
            <div className="flex items-center space-x-3">
              <img 
                src={isDarkMode ? "/stb-logo-w.gif" : "/stb-logo.gif"} 
                alt="STB" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold text-gray-900 dark:text-white">WORKSHOP</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="bg-orange-100 dark:bg-orange-900/20 rounded-full p-6">
              <Wrench className="h-16 w-16 text-orange-600 dark:text-orange-400" />
            </div>
          </div>
          
          {/* Title */}
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              Sistema en Mantenimiento
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-400">
              Temporalmente fuera de servicio
            </p>
          </div>

          {/* Message */}
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6">
            <div className="flex items-start space-x-3">
              <AlertTriangle className="h-6 w-6 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
              <div className="text-left">
                <h3 className="font-medium text-yellow-800 dark:text-yellow-200 mb-2">
                  Aviso Importante
                </h3>
                <p className="text-sm text-yellow-700 dark:text-yellow-300">
                  {message || 'El sitio se encuentra en mantenimiento. Por favor, intenta más tarde.'}
                </p>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="space-y-4">
            <div className="flex items-center justify-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
              <Clock className="h-4 w-4" />
              <span>Estaremos de vuelta pronto</span>
            </div>
            
            <div className="text-xs text-gray-400 dark:text-gray-500">
              <p>Si eres administrador, puedes acceder desde otra sesión.</p>
              <p className="mt-1">Para asistencia, contacta al equipo de soporte técnico.</p>
            </div>
          </div>

          {/* Animated loading indicator */}
          <div className="flex justify-center pt-6">
            <div className="flex space-x-1">
              <div className="h-2 w-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="h-2 w-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
              <div className="h-2 w-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="text-center text-sm text-gray-500 dark:text-gray-400">
            <p>© 2024 Servicios Técnicos de Bombeo - STB Workshop</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MaintenancePage;